<template>

    <v-layout col justify-start>
      <v-flex xs10 mx-0>
        <v-autocomplete  v-model="cemeteryWork.select" :items="cemeteryWork.cemeteries" item-text="name" item-value="id"
          :label='"Search for a cemetery"' :auto-select-first='true' v-focus autofocus
          :search-input.sync="cemeterySearch" :loading="cemeteryWork.loading"   return-object  @change="cemeteryChange()">     
        </v-autocomplete>
      </v-flex>
    </v-layout>    

</template>        

<script>

import CemeteryService from "@/services/CemeteryService" ;

export default {

  components: {  },
  props: {
    cemetery: null,
    person: null,
    ix: 0,
    container: null,
    containerProp: null
  },

  data () {
    return {
      addSeqForRid: -1,
      cemeteryWork: {
        select: {id: -1, name: ""}, 
        cemeteries: [],
        loading: false,
        origId: -1,
        pendingSearch: null
      },
      cemeterySearch: null  
    }
  },

  watch: {

    async cemeterySearch (val) {
      // if (val && val !== this.placeWork.select.pn && (val.length >= 2)) 
      // this.error = await this.$placeQuerySelections(val, this.placeWork) ; 
      console.log("IN EditCemetery SEARCH val: " + val + ", this.cemeteryWork.select=" + JSON.stringify(this.cemeteryWork.select)) ;
      if (val && val !== this.cemeteryWork.select.name && (val.length >= 2)) {
        this.cemeteryWork.select.id = -1 ; // ??
        this.runCemeterySearch(val, this.cemeteryWork) ;
      }             
    }
    /*
    place: function (oldVal, newVal) {
      console.log("- - - - - - ^^^^^EditPLACE place prop CHANGED from " + JSON.stringify(oldVal) + " to " + JSON.stringify(newVal)) ;
      if (newVal === null) {
        console.log("  EDITPLACE NEW IS NULL!") ;
        if (this.container && this.containerProp) {
          console.log("EDITPLACE Adding empty place type " + this.containerProp + " to container " + JSON.stringify(this.container)) ;
          this.containerProp[this.container] = {"rid":-1, "town": {"id":-1, "v":null}, "state": {"id": -1, "v":null}, "country": {"id": -1, "v":null}}
        }
      }
    }
    */
  },

  async created () {
    console.log("IN EditCemetery created, cemetery = " + JSON.stringify(this.cemetery) + " person " + this.person + " ix " + this.ix) ;
    /*
    if (!this.place) {
      if (this.container && this.containerProp) {
        console.log("Adding empty place type " + this.containerProp + " to container " + JSON.stringify(this.container)) ;
        this.container.xyz.abc = this.container.bollocks.id ;
        this.containerProp[this.container] = {"rid":-1, "town": {"id":-1, "v":null}, "state": {"id": -1, "v":null}, "country": {"id": -1, "v":null}}
      }
    }
    */
    if (this.cemetery && this.cemetery.id) {
      this.cemeteryWork.select.id = this.cemetery.id ;
      this.cemeteryWork.select.name = this.cemetery.name ;
      this.cemeteryWork.cemeteries = [{id: this.cemetery.id, name: this.cemetery.name}] ;
      console.log("IN EditCemetery created, cemeteryWork = " + JSON.stringify(this.cemeteryWork)) ;
    }
    // WAS this.$updatePlaceSelectionFromRecord(this.placeWork, this.place) ;
  },

  methods: {

    cemeteryChange () {
      console.log("---------------------------------cemeteryChange: " + JSON.stringify(this.cemeteryWork.select)) ;
      this.cemetery.newId = this.cemeteryWork.select.id ;
      if (this.cemetery.id <= 0) this.cemetery.id = this.cemeteryWork.select.id ;
      this.person.burial[this.ix].cemetery.id = this.cemeteryWork.select.id ;
      this.person.burial[this.ix].cemetery.name = this.cemeteryWork.select.n ;
      this.$forceUpdate() ;   // shouldnt have to do this..
    },

    async runCemeterySearch (val, locp) {

      console.log("runCemeterySearch val: " + val) ;
      if (locp.loading) {
        locp.pendingSearch = val ;
        console.log("PENDING SEARCH QUEUED: " + val) ;
        return ;
      }
      locp.loading = true ;
      try {
        const response = await CemeteryService.findMatchesOnName(val, "count") ;
        console.log("CemeteryService responsed: " + JSON.stringify(response)) ;      
        for (var c of response.data) c.name = c.n + " [" + c.c + "]" ;
        locp.cemeteries = response.data ;
      }
      catch (err) {
        console.log("runCemeterySearch catch err:" + JSON.stringify(err)) ;
        this.error = err.response.data.error  ;
      }
      finally {
        locp.loading = false ;
        if (locp.pendingSearch) {
          const queuedSearch = locp.pendingSearch ;
          locp.pendingSearch = null ;
          console.log("Queuing pending search.." + queuedSearch) ;
          this.runCemeterySearch(queuedSearch, locp) ;
        }
      }
    }
  } 
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Person/EditCemetery.vue